import { Box } from '@mui/material'
import { CustomerAnalyticsStyles } from './CustomerAnalyticsStyles';
import CustomerAnalyticsHeader from './CustomerAnalyticsHeader';
import SummaryCard from './SummaryCard';
import SessionList from './SessionList';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { getAllCustomerActivity, getAllCustomerActivityByDateRange } from './CustomerAnalyticsActions';
import CustomerAnalyticsFilters from './CustomerAnalyticsFilters';
import { ICustomerAnalyticsFilters, IGetAllCustomerActivityRequestBody, IGetAllCustomerActivityByDateRangeRequestBody } from '../../models/admin/customerAnalytics/customerAnalytics';

const CustomerAnalytics = () => {
  const dispatch = useAppDispatch()

  const [selectedAnalyticsType, setSelectedAnalyticsType] = useState(0);
  const [statusFilter, setStatusFilter] = useState('All');
  const [lobFilter, setLobFilter] = useState('All');
  const [selectedSession, setSelectedSession] = useState<{ customer: string, sessionId: string } | null>(null);
  const [filters, setFilters] = useState<ICustomerAnalyticsFilters>({
      fromDate: "",
      toDate: "",
      category : selectedAnalyticsType === 0 ? "Claim" : "Policy"
    });
  
  const handleAnalyticsTypeChange = (newType: number) => {
    setSelectedAnalyticsType(newType);
    setSelectedSession(null);
  };

  const handleDateChange = (type: "from" | "to", value: string) => {
    // If value is empty, reset the corresponding filter
    if (!value) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [type === "from" ? "fromDate" : "toDate"]: "",
      }));
      return;
    }

    // Only proceed with date formatting if we have a valid value
    const date = new Date(value);
    const formattedDate = date.toISOString();

    setFilters((prevFilters) => ({
      ...prevFilters,
      [type === "from" ? "fromDate" : "toDate"]: formattedDate,
    }));
  };

  const handleStatusChange = (status: string) => {
    setStatusFilter(status);
  };

  const handleLOBChange = (lob: string) => {
    setLobFilter(lob);
  };

  useEffect(()=>{
    if( (selectedAnalyticsType !== 0 && selectedAnalyticsType !== 1)) return;
    
    const requestBody: IGetAllCustomerActivityRequestBody = {
      category: selectedAnalyticsType === 0 ? "Claim" : "Policy"
    }

    // If date filters are present, use getAllCustomerActivityByDateRange
    if (filters.fromDate || filters.toDate) {
      const dateRangeBody: IGetAllCustomerActivityByDateRangeRequestBody = {
        ...requestBody,
        fromDate: filters.fromDate,
        toDate: filters.toDate
      };
      dispatch(getAllCustomerActivityByDateRange(dateRangeBody));
    } else {
      dispatch(getAllCustomerActivity(requestBody));
    }
  },[selectedAnalyticsType, filters.fromDate, filters.toDate])


  return (
    <Box sx={CustomerAnalyticsStyles.container}>
      <CustomerAnalyticsHeader 
        setSelectedAnalyticsType={handleAnalyticsTypeChange} 
        selectedAnalyticsType={selectedAnalyticsType}
      />
      <Box sx={CustomerAnalyticsStyles.summaryDateFilterContainer }>
        <SummaryCard selectedAnalyticsType={selectedAnalyticsType}/>
        <CustomerAnalyticsFilters 
          filters={filters} 
          handleDateChange={handleDateChange}
          onStatusChange={handleStatusChange}
          selectedAnalyticsType={selectedAnalyticsType}
          selectedLOB={lobFilter}
          onLOBChange={handleLOBChange}
        />
      </Box>
      <Box sx={CustomerAnalyticsStyles.bottomContainer}>
        <SessionList 
          selectedAnalyticsType={selectedAnalyticsType}
          statusFilter={statusFilter}
          lobFilter={lobFilter}
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
        />
      </Box>
    </Box>
  )
}

export default CustomerAnalytics